
import {
  computed,
  defineComponent,
  markRaw,
  PropType,
  ref,
  shallowRef,
  watch,
} from 'vue'

export default defineComponent({
  name: 'NlpCard',
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  setup (props) {
    const bodyRef = shallowRef<HTMLDivElement>()
    watch(() => props.loading, loading => {
      if (loading) {
        // 在加载新数据时滚动至顶部
        // 避免 nlp-card__body 子元素过长时, 用户滚动到底部后 el-loading 遮罩层无法遮盖到底部的问题
        bodyRef.value?.scrollTo(0, 0)
      }

    })

    return {
      bodyRef,
    }
  }
})
